import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-apollo';
import withPersonEntityTypeOrgQuery from '../withPersonEntityTypeOrg.graphql';
import useCurrentUser from './useCurrentUser';
export default function usePersonEntityTypeGroupSelector({ orgGroupIds, skip, } = {}) {
    const { me: { organisationGroupId }, } = useCurrentUser();
    const options = useMemo(() => ({
        variables: {
            orgGroupIds: orgGroupIds && !isEmpty(orgGroupIds)
                ? orgGroupIds
                : [organisationGroupId],
        },
        skip,
        fetchPolicy: 'cache-first',
    }), [orgGroupIds, skip, organisationGroupId]);
    const { data: { personEntityTypeGroupSelector = [] } = {}, error, loading, } = useQuery(withPersonEntityTypeOrgQuery, options);
    return {
        personEntityTypeGroupSelector,
        error,
        loading,
    };
}
